import React, {PropsWithChildren, useContext, useEffect, useState} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {RainforestPaymentMethodEnum} from "../enums/rainforest-payment-method.enum";
import {RainforestCardBrandEnum} from "../enums/rainforest-card-brand.enum";

export type RainforestFormEventType =
    | 'valid'
    | 'invalid'
    | 'approved'
    | 'declined'
    | 'method-updated'
    | 'card-brand-updated'
    | 'config-update-accepted'
    | 'config-update-ignored'
    | 'loaded';

export interface RainforestFormElement {
    addEventListener: (event: RainforestFormEventType, callback: (event: any) => void) => void;
    removeEventListener: (event: RainforestFormEventType, callback: (event: any) => void) => void;
    setAttribute: (name: string, value: string) => void;
    removeAttribute: (name: string) => void;
    submit: () => void;
}

export interface RainforestSessionResponse {
    session_key: string;
    allowed_methods: RainforestPaymentMethodEnum[];
}

export interface RainforestPayinResponse {
    payin_config_id: string;
}

export interface RainforestApproveEvent {
    detail: {data: {method_type: RainforestPaymentMethodEnum, payin_id: string, payin_config_id: string}}[];
}

interface RainforestContextState {
}

export const RainforestContext = React.createContext({} as RainforestContextState);

export const RainforestProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    useEffect(() => {
        if (data.company && data.company.is_rainforest_enabled) {
            const rainforestScriptElement = document.createElement('script');
            rainforestScriptElement.async = true;
            rainforestScriptElement.type = 'module';
            rainforestScriptElement.src = data.company.rainforest_api_url;
            document.body.appendChild(rainforestScriptElement);
        }
    }, [data.company]);

    return (
        <RainforestContext.Provider value={{}}>
            {children}
        </RainforestContext.Provider>
    )
}